// React
import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Components
import Skeleton from 'ui/blocks/Skeleton'
import { HostStyles, Availability } from './styles'

// Shared
import withStore from 'shop-components/utils/withStore'
import withTheme from 'shop-components/utils/withTheme'
import registerCustomElement from 'shop-components/utils/registerCustomElement'
import { withTranslation } from 'shared/utils/withTranslation'
import { fetchAvailabilities } from 'shop-components/redux/actions/availability'

const ProductAvailability = ({
  productId,
  isLoading,
  availability,
  cart,
  fetchProductAvailabilities,
  hideAvailability,
  setAttribute,
  t
}) => {
  useEffect(() => {
    if (productId && !!cart.startsAt && !!cart.stopsAt && !!cart.startLocationId) {
      fetchProductAvailabilities({
        id: productId,
        startsAt: cart.startsAt,
        stopsAt: cart.stopsAt,
        startLocationId: cart.startLocationId
      })
    }
  }, [cart.startsAt, cart.stopsAt, cart.startLocationId])

  useEffect(() => {
    if (!cart.startsAt || !cart.stopsAt || !availability) {
      setAttribute('visible', false)
    } else {
      setAttribute('visible', true)
    }
  }, [cart.startsAt, cart.stopsAt, availability])

  if (isLoading) return <Skeleton width={150} />

  if (!cart.startsAt || !cart.stopsAt || !availability) return null

  const availableString = hideAvailability ?
    t('user.store.available') :
    `${availability.plannable} ${t('user.store.available')?.toLowerCase?.()}`

  return (
    <Fragment>
      <HostStyles />
      <Availability available={!!availability?.plannable}>
        {availability?.plannable ? availableString : t('user.store.unavailable')}
      </Availability>
    </Fragment>
  )
}

ProductAvailability.displayName = 'ProductAvailability'

ProductAvailability.propTypes = {
  availability: PropTypes.object,
  isLoading: PropTypes.bool,
  hideAvailability: PropTypes.bool,
  cart: PropTypes.object,
  productId: PropTypes.string,
  fetchProductAvailabilities: PropTypes.func,
  setAttribute: PropTypes.func,
  t: PropTypes.func
}

const mapStateToProps = (state, props) => {
  let availability

  const cart = state.orm.carts.getById(state.client.cartId || window.booqableOptions.cart?.id)

  const item = state.items.records[props.productId]

  if (item?.products?.length > 1 && item?.type !== 'bundles') {
    availability = item?.products?.find(({ id }) => id === item.variation_id)?.availability
  } else {
    availability = item?.availability
  }

  return {
    cart: {
      id: cart?.id ?? window.booqableOptions.cart?.id,
      startsAt: cart?.starts_at ?? window.booqableOptions.cart?.from,
      stopsAt: cart?.stops_at ?? window.booqableOptions.cart?.till,
      startLocationId: cart?.start_location_id ?? window.booqableOptions.cart?.startLocationId
    },
    isLoading: state.items.loading && !availability,
    availability,
    hideAvailability: state.settings.get('store.hide_product_availability_quantities')
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  fetchProductAvailabilities: (attributes) => dispatch(fetchAvailabilities(attributes))
})

const decoratedComponent = compose(
  withStore,
  withTranslation('user'),
  withTheme,
  reduxConnect(mapStateToProps, mapDispatchToProps)
)(ProductAvailability)

registerCustomElement('bq-product-availability', decoratedComponent, {
  mountElement: 'span',
  attributes: ['product-id']
})

export default decoratedComponent
